uniform float uTime;
uniform vec2 uResolution;
uniform float uAlpha; // Uniform for controlling overall transparency
uniform float glowStrength; // Uniform for glow strength around grid lines
uniform vec3 uLineColor; // Uniform for grid line color
uniform vec3 uBackgroundColor; // Uniform for background color
varying vec2 vUv;

// Function to create a glowing line
float lineGlow(float dist, float lineWidth, float glowStrength) {
    return smoothstep(lineWidth + glowStrength, lineWidth, dist) - 
           smoothstep(lineWidth, lineWidth - glowStrength, dist);
}

void main() {
    vec2 uv = vUv * uResolution; // Adjust UV based on resolution

    // Grid setup
    float gridScale = 0.5; // Controls the size of the grid cells
    vec2 gridUV = fract(uv * gridScale);
    float lineThickness = 0.005; // Thickness of grid lines

    // Distance to nearest grid line in both x and y
    vec2 gridDist = min(gridUV, 1.0 - gridUV);
    float minDist = min(gridDist.x, gridDist.y);

    // Calculating the line glow
    float glow = lineGlow(minDist, lineThickness, glowStrength);

    // Radial fade effect
    vec2 center = vec2(0.5, 0.5); // Center of the UV coordinates
    float radius = 0.75; // Adjust as needed to control the size of the fade effect
    float distanceFromCenter = distance(uv / uResolution, center); // Calculate distance from center
    float edgeFade = smoothstep(0.0, radius * 0.8, distanceFromCenter); // Invert the fade effect

    // Use uLineColor for grid color, affected by glow and radial edge fade
    vec3 color = uLineColor * glow;

    // Allow uBackgroundColor
    // Calculate final color by mixing background and line colors
    // vec3 color = mix(uBackgroundColor, uLineColor, glow); 

    // Set the fragment color with controlled alpha, incorporating radial edge fading
    gl_FragColor = vec4(color, uAlpha * (1.0 - edgeFade) * glow);
}